import { useThemeContext } from '../providers/ThemeProvider';

/**
 * Hook to manage theme (light/dark mode).
 * Must be used within a ThemeProvider.
 */
export function useTheme() {
  const { theme, resolvedTheme, setTheme } = useThemeContext();

  const toggleTheme = () => {
    if (theme === 'light') {
      setTheme('dark');
    } else if (theme === 'dark') {
      setTheme('light');
    } else {
      // If system, toggle based on current resolved theme
      setTheme(resolvedTheme === 'light' ? 'dark' : 'light');
    }
  };

  return {
    theme,
    resolvedTheme,
    setTheme,
    toggleTheme,
    isDark: resolvedTheme === 'dark',
  };
}
